import React from 'react';
import Icon from '../../../../../../../generic-components/Icon';
import { invoicePageIcon } from '../../../../../../../assets/svg';

interface IBillDetailsHeaderProps {
  title: string;
}

const BillPreviewHeader = ({ title }: IBillDetailsHeaderProps) => (
  <div>
    <div className='h-[48px] flex flex-wrap flex-row border-b-[1px] border-bw03 justify-center items-center'>
      <Icon className='w-[20px] h-[20px] mr-[5px]' src={invoicePageIcon} />
      <div className='text-lg text-bw08'>{title}</div>
    </div>
  </div>
);

export default BillPreviewHeader;
